// #163 TR telefon formatı: rakamları al, başına 0 zorunlu koy, "(0532) 222 22 22"
// biçiminde göster. Toplam 11 hane (0 dahil). FieldText'in `format` prop'unda kullanılır.
export function formatTrPhone(v) {
  let d = String(v ?? '').replace(/\D/g, '');
  // Yapıştırılan +90 / 90 ülke kodunu at (12+ haneli, 90 ile başlıyorsa).
  if (d.startsWith('90') && d.length > 10) d = d.slice(2);
  // Talep 771.1 — ALAN KODU SİLİNEMİYORDU. Eskiden tek bir rakam kalsa bile başa 0
  // zorlanıp "(0…)" yeniden yazılıyordu; kullanıcı sona kadar silse elinde "(0)" kalıyor,
  // bir daha silince yine "(0)" üretiliyordu → alan ASLA temizlenemiyordu. Geriye tek
  // başına "0" (veya hiç rakam) kaldıysa bu, kullanıcının alanı boşaltma niyetidir.
  if (!d || d === '0') return '';
  if (d[0] !== '0') d = '0' + d; // başında 0 olsun
  d = d.slice(0, 11);
  const a = d.slice(0, 4);  // 0532
  const b = d.slice(4, 7);  // 222
  const c = d.slice(7, 9);  // 22
  const e = d.slice(9, 11); // 22
  let out = '(' + a + ')';
  if (b) out += ' ' + b;
  if (c) out += ' ' + c;
  if (e) out += ' ' + e;
  return out;
}

/**
 * Talep 748/771.1 — "eksik telefon girilse bile kaydediyor, uyarı vermeli".
 *
 * Boş = geçerli (telefon alanları zorunlu değil; zorunluluk ayrıca `req` ile yönetilir).
 * Doluysa 10 hane (5xx… — baştaki 0 yazılmamış) veya 11 hane (0…) kabul edilir.
 *
 * NEDEN TAM 11 DEĞİL: içeri aktarılan eski kayıtların bir kısmı baştaki 0 olmadan
 * 10 hane saklanıyor. Katı 11 kuralı bu müşterilerde telefonla ilgisi olmayan bir
 * düzenlemeyi bile kaydedilemez hâle getirirdi. Şikâyetin hedefi olan gerçek eksik
 * giriş (yalnız alan kodu → 3-4 hane) yine yakalanır. Aynı ölçüt
 * DistributorDetailPage'de de kullanılıyor (#771.1).
 * @returns {boolean} true = geçerli
 */
export function isCompleteTrPhone(v) {
  const d = String(v ?? '').replace(/\D/g, '');
  if (!d) return true;
  return d.length === 10 || d.length === 11;
}

/**
 * Talep 771.1 — "ALAN KODU SİLİNEMİYOR" hatasının ASIL sebebi ve genel çözümü.
 *
 * Maskeli bir alanda değer "(0532)" iken Backspace, metnin son karakterini — yani AYIRAÇ
 * olan ")" işaretini — siler. Rakam dizisi ("0532") DEĞİŞMEZ, dolayısıyla biçimlendirici
 * aynı çıktıyı yeniden üretir ve ")" anında geri gelir. Kullanıcı açısından tuş hiç
 * çalışmaz: imleç alan kodunun sonunda kilitlenir ve alan asla temizlenemez.
 *
 * Bu sarmalayıcı, ham metin KISALDIĞI hâlde rakamlar aynı kaldıysa "kullanıcı bir ayıraç
 * sildi" diye yorumlar ve son RAKAMI düşürür — böylece her Backspace ilerler.
 *
 * @param {(v: string) => string} formatFn Rakamlardan görünen metni üreten biçimlendirici.
 * @returns {(next: string, prev: string) => string} FieldText `format` prop'una verilebilir.
 */
export function withSeparatorDelete(formatFn) {
  return (next, prev) => {
    const nextStr = String(next ?? '');
    const prevStr = String(prev ?? '');
    const nextDigits = nextStr.replace(/\D/g, '');
    const prevDigits = prevStr.replace(/\D/g, '');
    if (nextStr.length < prevStr.length && nextDigits === prevDigits) {
      return formatFn(nextDigits.slice(0, -1));
    }
    return formatFn(nextStr);
  };
}

/** Silme tuzağına düşmeyen TR telefon biçimlendiricisi — FieldText `format` için. */
export const formatTrPhoneInput = withSeparatorDelete(formatTrPhone);
